import _classPrivateFieldInitSpec from "@babel/runtime/helpers/classPrivateFieldInitSpec";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet2";
var _registry = /*#__PURE__*/new WeakMap();
class CustomEditorRegistry {
  constructor() {
    _classPrivateFieldInitSpec(this, _registry, new Map());
  }
  define(editorName, editorFunc) {
    if (_classPrivateFieldGet(_registry, this).has(editorName)) {
      // eslint-disable-next-line no-console
      console.error(`Custom editor of "${editorName}" already registered`);
      return;
    }
    _classPrivateFieldGet(_registry, this).set(editorName, editorFunc);
  }
  get(editorName) {
    return _classPrivateFieldGet(_registry, this).get(editorName);
  }
}
export const customEditors = new CustomEditorRegistry();
//# sourceMappingURL=CustomEditors.js.map